module.exports = __webpack_public_path__ + "img/verve.541fc12a.png";